export const hasNonEmptyEntries = (obj: Record<string, ArrayLike<unknown>>): boolean => {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  return Object.values(obj).some((value) => value?.length > 0);
};
